<template>
    <div class="steps_nav">
        <btn-circle-icon icon="icon-arrow-left" class="next_step" @click.native="previousStep" :class="{disabled: prevStepDisabled}" />
        <div class="counter_steps"> {{currentStepNumber}}/{{ stepslength }}</div>
        <btn-circle-icon icon="icon-arrow-right" class="prev_step" @click.native="nextStep" :class="{disabled: nextStepDisabled}" />
    </div>
</template>

<script>
export default {
    name: 'TopbarSteps',
    components: {},
    data(){
        return {

        }
    },
    computed: {
        currentStepNumber(){
            return this.$store.state.RefStore.formCurrentStep + 1
        },
        stepslength(){
            return this.$store.state.RefStore.formStepsName.length
        },
        prevStepDisabled(){
            if(this.currentStepNumber == this.stepslength){
                return true
            }else{
                return this.$store.state.RefStore.formCurrentStep == 0
            }
        },
        nextStepDisabled(){
            return !this.$store.state.RefStore.formValidity[this.$store.state.RefStore.formCurrentStep]
        }
    },
    methods: {
        previousStep(){
            if(!this.prevStepDisabled){
                this.$store.commit('RefStore/changeCurrentStep', { index: this.currentStepNumber - 2 })
            }
        },
        nextStep(){
            if(!this.nextStepDisabled){
                this.$store.commit('RefStore/changeCurrentStep', { index: this.currentStepNumber })
            }
        }
    }
}
</script>
<style>
    .steps_nav{
        padding-right: 90px;
    }
</style>